import classNames from 'classnames';

import { setupForDark } from '@theme';

function SectionTitle({
  text,
  center = false,
  bold = false,
  className = ''
}: {
  text: string;
  center?: boolean;
  className?: string;
  bold?: boolean;
}) {
  return (
    <div
      className={classNames(
        'uppercase h-full',
        bold ? 'LS2B' : 'LS2M',
        'items-center justify-left',
        setupForDark('text-secondary'),
        center ? 'text-center' : '',
        'truncate',
        className
      )}
    >
      {text}
    </div>
  );
}

export default SectionTitle;
